import { emptyFragment, Typography } from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';
import { T } from '../../../../../../../../../../Translations';
import { ExperienceResource } from '../../../../../Types';

interface Props {
  experienceResource: ExperienceResource;
}

function ProgramHours({ experienceResource }: Props) {
  return experienceResource.payload.total_hours
    .map((count) => (
      <Typography className="text-foreground" variant="caption">
        <T kind="{{count}} Hour" count={count} />
      </Typography>
    ))
    .getOrElse(emptyFragment);
}

export default observer(ProgramHours);
